export const SUBSCRIPTION_ENABLED = 'subscription.enabled';
